const revokedAcceptanceTokens = new Set<string>();

export function buildInvitationAcceptanceUrl(
  portalOrigin: string,
  acceptanceToken: string,
): string {
  const invitationAcceptanceUrl = new URL('/invite', portalOrigin);
  invitationAcceptanceUrl.searchParams.set('token', acceptanceToken);
  return invitationAcceptanceUrl.toString();
}

export function getAcceptanceTokenFromLink(link: string): string | null {
  try {
    return new URL(link).searchParams.get('token')?.trim() || null;
  } catch {
    return null;
  }
}

export function revokeInvitationLink(link: string): void {
  const acceptanceToken = getAcceptanceTokenFromLink(link);
  if (!acceptanceToken) return;
  revokedAcceptanceTokens.add(acceptanceToken);
}

export function isAcceptanceTokenRevoked(acceptanceToken: string): boolean {
  return revokedAcceptanceTokens.has(acceptanceToken);
}
